/* Models */
import { Carousel } from '../models';

/* ActionTypes */
import { CAROUSEL_ENTITY_ACTION_TYPES } from './actionTypes';

/* Utils */
import { generateEntityReducer } from '../utils/generators/reducerGenerators';

const carouselsReducer = generateEntityReducer(CAROUSEL_ENTITY_ACTION_TYPES, Carousel);

export default carouselsReducer;
